export const sortQuizzes = (quizzes) =>{
	return quizzes.sort((q1,q2)=>{
		if(q1.number!==undefined && q2.number!==undefined){
			return q1.number-q2.number;
		}
		return q1.question-q2.question;
	});
};

export const shuffleQuizzes = (quizzes) => {
	return quizzes.reduce( 
		(newArr, _, i) => {
			var rand = i + ( Math.floor( Math.random() * (newArr.length - i) ) );
			[newArr[rand], newArr[i]] = [newArr[i], newArr[rand]];
			return newArr;
		}, [...quizzes]
	);
};
export const insertNumer = (quizzes) =>{
	return quizzes.map((quiz,idx)=>({...quiz,number:idx+1}));
};

const hasAnswer = (quiz) => {
	return quiz.answers && quiz.answers.length > 0;
}

export const checkForValidQuiz  = (quiz,isSample) => {
	if(isSample){
		return quiz.isSample && hasAnswer(quiz);
	}
	return !quiz.isSample && hasAnswer(quiz) && quiz.checked;
};